import { render, staticRenderFns } from "./company-location-card.vue?vue&type=template&id=645942fa&scoped=true&"
import script from "./company-location-card.vue?vue&type=script&lang=js&"
export * from "./company-location-card.vue?vue&type=script&lang=js&"
import style0 from "./company-location-card.vue?vue&type=style&index=0&id=645942fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645942fa",
  null
  
)

export default component.exports